(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "normalizr", "../setting", "../../topic/schema", "../../user/schema", "../util", "../../topic/util/topicCheckers", "../../topic/util/topicGetters"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("normalizr"), require("../setting"), require("../../topic/schema"), require("../../user/schema"), require("../util"), require("../../topic/util/topicCheckers"), require("../../topic/util/topicGetters"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.normalizr, global.setting, global.schema, global.schema, global.util, global.topicCheckers, global.topicGetters);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _normalizr, _setting, _schema, _schema2, _util, _topicCheckers, _topicGetters) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.conversationSchema = void 0;
  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  /**
   * Schema for a single conversation
   * @type {schema.Entity}
   */
  var conversationSchema = new _normalizr.schema.Entity(_setting.conversationEntityKey, {
    topic: _schema.topicSchema,
    participants: _schema2.usersSchema
  }, {
    processStrategy: function processStrategy(entity) {
      // The websocket may return a conversation with participants but the topic object doesn't contain them.
      // This will make sure to copy the participant list into topic object for groups/fishbowl
      var participants = entity.participants && (0, _util.getConversationParticipants)(entity);
      if (participants) {
        var topic = (0, _util.getConversationTopic)(entity);
        if ((0, _topicCheckers.isGroupTopic)(topic)) {
          var groupTopic = _objectSpread({}, (0, _topicGetters.getGroupTopic)(topic));
          if (!groupTopic.participants) {
            groupTopic.participants = participants;
            return _objectSpread(_objectSpread({}, entity), {}, {
              topic: groupTopic
            });
          }
        }
      }
      return _objectSpread({}, entity);
    }
  });
  _exports.conversationSchema = conversationSchema;
});